query RetourQuery($uri: String, $siteId: Int) {
  retour(uri: $uri, siteId: $siteId) {
    redirectDestUrl
    redirectHttpCode
    enabled
  }
}
